import React from 'react'
import { Link } from 'gatsby'
import cx from 'classnames'

import { Image } from 'src/components/image'

const options: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
}
const formatter = new Intl.DateTimeFormat('en-US', options)

const formatDate = (value?: string) => {
  if (!value) {
    return ''
  }

  const time = Date.parse(value)

  return Number.isNaN(time) ? '' : formatter.format(time)
}

export const EditorialCard = ({
  title,
  image,
  cardImage,
  className,
  articleType,
  topics,
  slug,
  articleColor,
  authors,
  publishedAt,
  updatedAt,
  fromArticle,
}: {
  title: string
  slug: {
    current: string
  }
  cardImage?: {
    asset: {
      _id: string
    }
  }
  className?: string
  articleColor?: string
  authors?: any[]
  topics?: Array<{
    title: string
  }>
  articleType?: {
    title: string
  }
  publishedAt?: string
  updatedAt?: string
  image: {
    asset: {
      _id: string
    }
  }
  fromArticle: boolean
}) => {
  const authorNames = authors
    ?.map(author => author?.content?.main?.title)
    .filter(Boolean)
    .join(', ')
  const publishedDate = formatDate(publishedAt)
  const updatedDate = formatDate(updatedAt)
  const categoryLabel =
    topics
      ?.map(topic => topic?.title)
      .filter(Boolean)
      .join(', ') || articleType?.title

  return (
    <Link
      to={`/article/${slug?.current}/`}
      className={cx('editorial__card', articleColor, className)}
    >
      <div className="editorial__card-image rel">
        {cardImage ? (
          <Image
            fromArticle={fromArticle}
            className="abs y x"
            imageId={cardImage.asset._id}
            raw={cardImage}
            size={800}
            alt={title}
          />
        ) : (
          <Image className="abs y x" imageId={image?.asset?._id} alt={title} />
        )}
      </div>
      <div className="editorial__card-content p1">
        <div>
          {categoryLabel && (
            <h5 className="editorial__card-category caps mt0 pt0 mb0 pb0 mono">
              {categoryLabel}
            </h5>
          )}
          <h3 className="mt05">{title}</h3>
        </div>
        {(authorNames || publishedDate || updatedDate) && (
          <div className="editorial__card-meta mono caps">
            {authorNames && <span>By {authorNames}</span>}
            {publishedDate && <span>Published {publishedDate}</span>}
            {updatedDate && <span>Updated {updatedDate}</span>}
          </div>
        )}
      </div>
    </Link>
  )
}
